module.exports = __webpack_public_path__ + "img/gartek-services-plumbing-fuel-expert.ea493ba9.png";